module.exports = __webpack_public_path__ + "images/rich_heading/brand/jewel/icon_96e6a5ae706686ed39f41fcd900dfcd9.png";